import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaRupeeSign, FaStar } from 'react-icons/fa';

const CollegeCard = ({ college }) => {
  return (
    <div className="card card-hover group">
      {/* College Banner */}
      <div className="relative h-48 overflow-hidden">
        {college.banner_url ? (
          <img
            src={college.banner_url}
            alt={college.name}
            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center">
            <span className="text-white text-6xl font-bold opacity-20">
              {college.name.charAt(0)}
            </span>
          </div>
        )}
        {college.featured && (
          <div className="absolute top-3 right-3 bg-secondary-500 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center">
            <FaStar className="mr-1" /> Featured
          </div>
        )}
      </div>

      {/* College Info */}
      <div className="p-6">
        {/* College Type Badge */}
        <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-3">
          {college.college_type ? college.college_type.charAt(0).toUpperCase() + college.college_type.slice(1) : 'College'}
        </span>

        <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
          {college.name}
        </h3>

        <div className="flex items-center text-gray-600 text-sm mb-3">
          <FaMapMarkerAlt className="mr-2 text-primary-500" />
          <span className="line-clamp-1">{college.location}</span>
        </div>

        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {college.description || 'Quality education with excellent facilities and experienced faculty.'}
        </p>

        {/* Fees Range */}
        {college.fees_range_min && college.fees_range_max && (
          <div className="flex items-center text-gray-700 mb-4">
            <FaRupeeSign className="text-primary-500 mr-1" />
            <span className="font-semibold">
              {college.fees_range_min.toLocaleString()} - {college.fees_range_max.toLocaleString()}
            </span>
            <span className="text-xs text-gray-500 ml-1">/year</span>
          </div>
        )}

        {/* Courses Preview */}
        {college.courses_offered && (
          <div className="mb-4">
            <p className="text-xs text-gray-500 mb-1">Popular Courses:</p>
            <p className="text-sm text-gray-700 line-clamp-1">
              {college.courses_offered}
            </p>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-2">
          <Link
            to={`/colleges/${college.slug}`}
            className="flex-1 btn btn-primary text-sm py-2"
          >
            View Details
          </Link>
          <Link
            to="/register"
            className="flex-1 btn btn-secondary text-sm py-2"
          >
            Apply Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CollegeCard;
